import { useState } from "react";
import AccordionItem, {
  AccordionItemProps,
} from "@/components/Accordion/AccordionItem/AccordionItem";
import { AccordionContainer, AccordionInner } from "./styles";
import gsap from "@/lib/gsap";
import React from "react";

type Props = {
  _key: string;
  _type: string;
  items?: AccordionItemProps[];
};

const Accordion: React.FC<Props> = (props) => {
  const { items } = props;
  const [activeItem, setActiveItem] = useState<null | string>("");

  async function handleClick(target: HTMLElement, id: string | undefined) {
    if (!id) return;
    if (activeItem == id) {
      setActiveItem("");
    } else {
      setActiveItem(id);
    }
    await gsap.to(window, {
      scrollTo: { y: target, offsetY: 100 },
      delay: 0.6,
    });
  }

  return (
    <AccordionContainer>
      <AccordionInner>
        {items &&
          items.map((item) => (
            <AccordionItem
              key={item._key}
              {...item}
              isOpen={item._key == activeItem}
              handleClick={(event: React.MouseEvent<HTMLElement>) =>
                handleClick(event.currentTarget, item._key)
              }
            />
          ))}
      </AccordionInner>
    </AccordionContainer>
  );
};

export default Accordion;
